import {DataObjectId, Hub} from 'yougile-model'
import {Items} from '@api/model/items'
import {Board} from '@extensions/board'
import {PermissionsChecker} from './permissions-checker'
import {Sync} from './sync'

export const deleteAllowed = (id: DataObjectId): boolean =>
  Items.allowDelete(Items.get(id)) &&
  PermissionsChecker.checkDeletion(Sync.getCurrentSandbox().get(id) as Hub)

export const renameAllowed = (id: DataObjectId): boolean =>
  Items.allowRename(Items.get(id)) &&
  PermissionsChecker.checkRename(Sync.getCurrentSandbox().get(id) as Hub)

export const addingAllowed = (id?: DataObjectId): boolean => {
  if (!id) {
    return false
  }

  const hub = Sync.getCurrentSandbox().get(id) as Hub
  return (
    hub &&
    Items.allowAdd(Items.get(id)) &&
    PermissionsChecker.checkAddChildTo(hub)
  )
}

export const addingAllowedToBoard = (board?: Hub): boolean => {
  if (!board) {
    return false
  }

  const columns = Board.listColumns(board)
  const canAddToAnyColumn = columns.some(c => addingAllowed(c.id))

  return canAddToAnyColumn
}

export const archiveAllowed = (id: DataObjectId): boolean =>
  PermissionsChecker.checkArchive(Sync.getCurrentSandbox().get(id) as Hub)

export const moveAllowed = (
  id: DataObjectId,
  fromId: DataObjectId,
  toId: DataObjectId
): boolean => {
  const obj = Sync.getCurrentSandbox().get(id) as Hub
  const from = Sync.getCurrentSandbox().get(fromId) as Hub
  const to = Sync.getCurrentSandbox().get(toId) as Hub

  const itemsMove = Items.move(
    Items.fromHub(obj),
    Items.fromHub(from),
    Items.fromHub(to)
  )

  return itemsMove && PermissionsChecker.checkMove(obj, from, to)
}

export const moveFromAllowedByPermissions = (
  id: DataObjectId,
  fromId: DataObjectId
): boolean => {
  const obj = Sync.getCurrentSandbox().get(id) as Hub
  const from = Sync.getCurrentSandbox().get(fromId) as Hub
  return PermissionsChecker.checkMoveFrom(obj, from)
}
